// [claude-code 2026-04-04] T1: Internal connectors — in-app features that appear in the Connectors list
import type { McpServerConfig } from "../types/mcp";

/**
 * Internal connectors are NOT MCP servers. They are in-app features routed
 * through Harper chat that appear alongside MCP connectors in the composer toolbox.
 * When active, they inject context into Harper's system prompt or trigger backend endpoints.
 */
export const INTERNAL_CONNECTORS: McpServerConfig[] = [
  {
    id: "arbitrum",
    name: "Arbitrum",
    description:
      "Attach the live Arbitrum run, CAO synthesis, report packets, and handoff context.",
    transport: "stdio",
    command: "",
    args: [],
    enabled: true,
    installed: true,
    requiresApiKey: false,
    hasApiKey: true,
    category: "internal",
    locked: true,
    source: "internal",
  },
  {
    id: "narrativeflow",
    name: "NarrativeFlow",
    description:
      "Attach NarrativeFlow sessions, Docs, Timeline, Canvas, and DeskMap state.",
    transport: "stdio",
    command: "",
    args: [],
    enabled: true,
    installed: true,
    requiresApiKey: false,
    hasApiKey: true,
    category: "internal",
    locked: true,
    source: "internal",
  },
  {
    id: "riskflow",
    name: "RiskFlow",
    description:
      "Attach internal RiskFlow catalyst headlines, risk signals, and scores.",
    transport: "stdio",
    command: "",
    args: [],
    enabled: true,
    installed: true,
    requiresApiKey: false,
    hasApiKey: true,
    category: "internal",
    locked: true,
    source: "internal",
  },
  {
    id: "desk-plans",
    name: "Desk Plans",
    description:
      "Attach all current Desk Plan context, planned catalysts, and workflow state.",
    transport: "stdio",
    command: "",
    args: [],
    enabled: true,
    installed: true,
    requiresApiKey: false,
    hasApiKey: true,
    category: "internal",
    locked: true,
    source: "internal",
  },
  {
    id: "consul-control",
    name: "QuickScout",
    description:
      "Attach Electron Desktop screen and read-only app/browser control context.",
    transport: "stdio",
    command: "",
    args: [],
    enabled: true,
    installed: true,
    requiresApiKey: false,
    hasApiKey: true,
    category: "internal",
    locked: true,
    source: "internal",
  },
];
